module.exports = __webpack_public_path__ + "img/Imagemtermo.fw.baf29989.png";